import React, { useState } from 'react';
import { DollarSign, Plus, Trash2, Edit2, Save, X, AlertTriangle, Tag } from 'lucide-react';

export default function PricingConfigSection({ config, onChange }) {
  const [editingItem, setEditingItem] = useState(null);
  const [editForm, setEditForm] = useState({});

  // Initialize default pricing structure if not exists
  const pricingData = config?.pricingTable || {
    futs: [
      { id: 1, name: 'Barrique noire 270L — Offre Été 2026 (PRIORITAIRE)', description: '🎁 OFFERTE + transport France-Abidjan + dédouanement + livraison Abidjan = 160€ TTC. Paiement : 50€ à la livraison barrique vide + 110€ à l\'enlèvement.', price: 160 },
      { id: 2, name: 'Barrique bleue 220L', description: 'Barrique vide Paris : 40€ | Barrique vide Banlieue : 45€ | Transport Abidjan : 140€', price: 40 }
    ],
    televiseurs: [
      { id: 1, size: '32"', cm: '82cm', priceOccasion: 90, priceNeuf: 100 },
      { id: 2, size: '38"', cm: '96,52cm', priceOccasion: 105, priceNeuf: 125 },
      { id: 3, size: '41"', cm: '105cm', priceOccasion: 110, priceNeuf: 130 },
      { id: 4, size: '42"', cm: '107cm', priceOccasion: 130, priceNeuf: 200 },
      { id: 5, size: '43"', cm: '108cm', priceOccasion: 140, priceNeuf: 220 },
      { id: 6, size: '44"', cm: '110cm', priceOccasion: 145, priceNeuf: 235 },
      { id: 7, size: '47"', cm: '116cm', priceOccasion: 150, priceNeuf: 250 },
      { id: 8, size: '50"', cm: '127cm', priceOccasion: 170, priceNeuf: 270 },
      { id: 9, size: '52"', cm: '132cm', priceOccasion: 190, priceNeuf: 230 },
      { id: 10, size: '55"', cm: '140cm', priceOccasion: 220, priceNeuf: 260 },
      { id: 11, size: '60"', cm: '155cm', priceOccasion: 230, priceNeuf: 270 },
      { id: 12, size: '65"', cm: '165cm', priceOccasion: 250, priceNeuf: 280 },
      { id: 13, size: '70"', cm: '178cm', priceOccasion: 300, priceNeuf: 350 },
      { id: 14, size: '72"', cm: '183cm', priceOccasion: 320, priceNeuf: 370 },
      { id: 15, size: '75"', cm: '190cm', priceOccasion: 350, priceNeuf: 400 },
      { id: 16, size: '80"', cm: '203cm', priceOccasion: 410, priceNeuf: 460 },
      { id: 17, size: '85"', cm: '216cm', priceOccasion: 450, priceNeuf: 500 }
    ],
    electromenager: [
      { id: 1, name: 'Congélateur 140cm', price: 300 },
      { id: 2, name: 'Congélateur couché 170', price: 550 },
      { id: 3, name: 'Gazinière 4 feux', price: 150 },
      { id: 4, name: 'Four encastrable', price: 160 },
      { id: 5, name: 'Micro-ondes', price: 50 },
      { id: 6, name: 'Cuisinière standard', price: 160 },
      { id: 7, name: 'Lave-linge standard', price: 160 },
      { id: 8, name: 'Cuiseur de riz', price: 40 },
      { id: 9, name: 'Frigo vide 140cm', price: 160 },
      { id: 10, name: 'Frigo vide 170cm', price: 190 },
      { id: 11, name: 'Frigo vide 180cm', price: 210 },
      { id: 12, name: 'Frigo vide 190cm', price: 230 },
      { id: 13, name: 'Frigo vide 195cm', price: 250 },
      { id: 14, name: 'Congélateur 80cm', price: 180 },
      { id: 15, name: 'Congélateur 90cm', price: 220 },
      { id: 16, name: 'Congélateur 110cm', price: 250 }
    ],
    cantines: [
      { id: 1, size: '80cm', price: 100 },
      { id: 2, size: '90cm', price: 120 },
      { id: 3, size: '100cm', price: 140 },
      { id: 4, size: '110cm', price: 150 },
      { id: 5, size: '120cm', price: 160 },
      { id: 6, size: '130cm', price: 170 }
    ],
    mobilier: [
      { id: 1, name: 'Canapés / Fauteuils', unit: 'par place', price: 120 },
      { id: 2, name: 'Chaises', unit: 'par unité', price: 20 },
      { id: 3, name: 'Table à manger 4 personnes', unit: 'unité', price: 160 },
      { id: 4, name: 'Table à manger 6 personnes', unit: 'unité', price: 220 }
    ],
    cartons: [
      { id: 1, dimensions: '60 x 50 x 40 cm', price: 70 },
      { id: 2, dimensions: '80 x 40 x 36 cm', price: 90 },
      { id: 3, dimensions: '80 x 50 x 50 cm', price: 100 },
      { id: 4, dimensions: '100 x 50 x 50 cm', price: 110 },
      { id: 5, dimensions: '101 x 54 x 54 cm', price: 120 }
    ],
    promotions: [
      { id: 1, code: 'BIENVENUE10', discount: 10, conditions: 'Première commande uniquement', active: true },
      { id: 2, code: 'FIDELE15', discount: 15, conditions: 'À partir de 3 envois', active: true },
      { id: 3, code: 'NOEL2024', discount: 20, conditions: 'Valable jusqu\'au 31 décembre 2024', active: false }
    ],
    exclusions: [
      'Alcool et boissons alcoolisées'
    ]
  };

  const handleUpdatePricing = (category, items) => {
    onChange({
      ...config,
      pricingTable: {
        ...pricingData,
        [category]: items
      }
    });
  };

  const handleAddItem = (category) => {
    const newItem = {
      id: Date.now(),
      ...(category === 'televiseurs' ? { size: '', cm: '', priceOccasion: 0, priceNeuf: 0 } :
          category === 'futs' ? { name: '', description: '', price: 0 } :
          category === 'cantines' ? { size: '', price: 0 } :
          category === 'cartons' ? { dimensions: '', price: 0 } :
          category === 'mobilier' ? { name: '', unit: '', price: 0 } :
          category === 'promotions' ? { code: '', discount: 0, conditions: '', active: true } :
          { name: '', price: 0 })
    };
    handleUpdatePricing(category, [...pricingData?.[category], newItem]);
  };

  const handleDeleteItem = (category, id) => {
    handleUpdatePricing(
      category,
      pricingData?.[category]?.filter(item => item?.id !== id)
    );
  };

  const handleEditItem = (category, item) => {
    setEditingItem({ category, id: item?.id });
    setEditForm(item);
  };

  const handleSaveEdit = () => {
    if (!editingItem) return;
    const { category, id } = editingItem;
    handleUpdatePricing(
      category,
      pricingData?.[category]?.map(item => item?.id === id ? editForm : item)
    );
    setEditingItem(null);
    setEditForm({});
  };

  const handleCancelEdit = () => {
    setEditingItem(null);
    setEditForm({});
  };

  const handleAddExclusion = () => {
    const newExclusion = prompt('Ajouter une exclusion:');
    if (newExclusion) {
      onChange({
        ...config,
        pricingTable: {
          ...pricingData,
          exclusions: [...(pricingData?.exclusions || []), newExclusion]
        }
      });
    }
  };

  const handleDeleteExclusion = (index) => {
    onChange({
      ...config,
      pricingTable: {
        ...pricingData,
        exclusions: pricingData?.exclusions?.filter((_, i) => i !== index)
      }
    });
  };

  return (
    <div className="space-y-8">
      <div className="flex items-center space-x-2 mb-4">
        <DollarSign className="text-green-600" size={24} />
        <h2 className="text-xl font-semibold text-gray-900">Grille Tarifaire Complète</h2>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          <strong>📦 Transit Maritime - Tarification au Volume</strong>
        </p>
        <p className="text-sm text-blue-700 mt-2">
          En transit maritime, nous ne considérons pas le poids mais uniquement le volume. 
          Les tarifs ci-dessous sont fixes par article/dimension.
        </p>
      </div>

      {/* Promotions Section - NEW */}
      <div className="bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <Tag className="text-purple-600" size={24} />
            <h3 className="text-lg font-semibold text-gray-900">🎁 Promotions & Codes Promo</h3>
          </div>
          <button
            onClick={() => handleAddItem('promotions')}
            className="text-sm bg-purple-600 text-white px-3 py-1 rounded hover:bg-purple-700 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg">
            <thead className="bg-purple-100">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Code Promo</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Réduction (%)</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Conditions</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Statut</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pricingData?.promotions?.map((item) => (
                <tr key={item?.id} className={item?.active ? '' : 'bg-gray-50 opacity-60'}>
                  {editingItem?.category === 'promotions' && editingItem?.id === item?.id ? (
                    <>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.code}
                          onChange={(e) => setEditForm({ ...editForm, code: e?.target?.value?.toUpperCase() })}
                          className="w-full px-2 py-1 border rounded font-mono"
                          placeholder="CODEPROMO"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.discount}
                          onChange={(e) => setEditForm({ ...editForm, discount: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                          min="0"
                          max="100"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.conditions}
                          onChange={(e) => setEditForm({ ...editForm, conditions: e?.target?.value })}
                          className="w-full px-2 py-1 border rounded"
                          placeholder="Conditions d'utilisation"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <select
                          value={editForm?.active ? 'true' : 'false'}
                          onChange={(e) => setEditForm({ ...editForm, active: e?.target?.value === 'true' })}
                          className="px-2 py-1 border rounded"
                        >
                          <option value="true">Actif</option>
                          <option value="false">Inactif</option>
                        </select>
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button onClick={handleSaveEdit} className="text-green-600 hover:text-green-800">
                            <Save size={16} />
                          </button>
                          <button onClick={handleCancelEdit} className="text-gray-600 hover:text-gray-800">
                            <X size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2">
                        <span className="font-mono text-sm font-semibold text-purple-700 bg-purple-100 px-2 py-1 rounded">
                          {item?.code}
                        </span>
                      </td>
                      <td className="px-4 py-2">
                        <span className="text-sm font-bold text-green-600">{item?.discount}%</span>
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-700">{item?.conditions}</td>
                      <td className="px-4 py-2 text-center">
                        {item?.active ? (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            ✓ Actif
                          </span>
                        ) : (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                            ✕ Inactif
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button
                            onClick={() => handleEditItem('promotions', item)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteItem('promotions', item?.id)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-4 bg-purple-100 border border-purple-200 rounded p-3">
          <p className="text-sm text-purple-800">
            <strong>💡 Utilisation des codes promo:</strong> Fatou informera automatiquement les clients des promotions actives. 
            Les codes inactifs ne seront pas mentionnés mais restent dans le système pour référence.
          </p>
        </div>
      </div>

      {/* Exclusions */}
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <AlertTriangle className="text-red-600" size={20} />
            <h3 className="font-semibold text-red-900">Exclusions - Articles Non Acceptés</h3>
          </div>
          <button
            onClick={handleAddExclusion}
            className="text-sm text-red-600 hover:text-red-800 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <ul className="space-y-2">
          {pricingData?.exclusions?.map((exclusion, index) => (
            <li key={index} className="flex items-center justify-between bg-white p-2 rounded border border-red-200">
              <span className="text-sm text-red-800">❌ {exclusion}</span>
              <button
                onClick={() => handleDeleteExclusion(index)}
                className="text-red-600 hover:text-red-800"
              >
                <Trash2 size={16} />
              </button>
            </li>
          ))}
        </ul>
      </div>
      {/* Fûts */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">🛢️ Fûts (Barriques)</h3>
          <button
            onClick={() => handleAddItem('futs')}
            className="text-sm bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Nom</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Description</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Prix (€)</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pricingData?.futs?.map((item) => (
                <tr key={item?.id}>
                  {editingItem?.category === 'futs' && editingItem?.id === item?.id ? (
                    <>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.name}
                          onChange={(e) => setEditForm({ ...editForm, name: e?.target?.value })}
                          className="w-full px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.description}
                          onChange={(e) => setEditForm({ ...editForm, description: e?.target?.value })}
                          className="w-full px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.price}
                          onChange={(e) => setEditForm({ ...editForm, price: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button onClick={handleSaveEdit} className="text-green-600 hover:text-green-800">
                            <Save size={16} />
                          </button>
                          <button onClick={handleCancelEdit} className="text-gray-600 hover:text-gray-800">
                            <X size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 text-sm text-gray-900">{item?.name}</td>
                      <td className="px-4 py-2 text-sm text-gray-600">{item?.description}</td>
                      <td className="px-4 py-2 text-sm font-medium text-gray-900">{item?.price}€</td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button
                            onClick={() => handleEditItem('futs', item)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteItem('futs', item?.id)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Téléviseurs */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">📺 Téléviseurs (Occasion / Neuf)</h3>
          <button
            onClick={() => handleAddItem('televiseurs')}
            className="text-sm bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Taille</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Centimètres</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Prix Occasion (€)</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Prix Neuf (€)</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pricingData?.televiseurs?.map((item) => (
                <tr key={item?.id}>
                  {editingItem?.category === 'televiseurs' && editingItem?.id === item?.id ? (
                    <>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.size}
                          onChange={(e) => setEditForm({ ...editForm, size: e?.target?.value })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.cm}
                          onChange={(e) => setEditForm({ ...editForm, cm: e?.target?.value })}
                          className="w-24 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.priceOccasion}
                          onChange={(e) => setEditForm({ ...editForm, priceOccasion: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.priceNeuf}
                          onChange={(e) => setEditForm({ ...editForm, priceNeuf: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button onClick={handleSaveEdit} className="text-green-600 hover:text-green-800">
                            <Save size={16} />
                          </button>
                          <button onClick={handleCancelEdit} className="text-gray-600 hover:text-gray-800">
                            <X size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 text-sm text-gray-900">{item?.size}</td>
                      <td className="px-4 py-2 text-sm text-gray-600">({item?.cm})</td>
                      <td className="px-4 py-2 text-sm font-medium text-gray-900">{item?.priceOccasion}€</td>
                      <td className="px-4 py-2 text-sm font-medium text-gray-900">{item?.priceNeuf}€</td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button
                            onClick={() => handleEditItem('televiseurs', item)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteItem('televiseurs', item?.id)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Électroménager */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">🔌 Électroménager</h3>
          <button
            onClick={() => handleAddItem('electromenager')}
            className="text-sm bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Article</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Prix (€)</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pricingData?.electromenager?.map((item) => (
                <tr key={item?.id}>
                  {editingItem?.category === 'electromenager' && editingItem?.id === item?.id ? (
                    <>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.name}
                          onChange={(e) => setEditForm({ ...editForm, name: e?.target?.value })}
                          className="w-full px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.price}
                          onChange={(e) => setEditForm({ ...editForm, price: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button onClick={handleSaveEdit} className="text-green-600 hover:text-green-800">
                            <Save size={16} />
                          </button>
                          <button onClick={handleCancelEdit} className="text-gray-600 hover:text-gray-800">
                            <X size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 text-sm text-gray-900">{item?.name}</td>
                      <td className="px-4 py-2 text-sm font-medium text-gray-900">{item?.price}€</td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button
                            onClick={() => handleEditItem('electromenager', item)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteItem('electromenager', item?.id)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Cantines */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">🧳 Cantines</h3>
          <button
            onClick={() => handleAddItem('cantines')}
            className="text-sm bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Taille</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Prix (€)</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pricingData?.cantines?.map((item) => (
                <tr key={item?.id}>
                  {editingItem?.category === 'cantines' && editingItem?.id === item?.id ? (
                    <>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.size}
                          onChange={(e) => setEditForm({ ...editForm, size: e?.target?.value })}
                          className="w-24 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.price}
                          onChange={(e) => setEditForm({ ...editForm, price: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button onClick={handleSaveEdit} className="text-green-600 hover:text-green-800">
                            <Save size={16} />
                          </button>
                          <button onClick={handleCancelEdit} className="text-gray-600 hover:text-gray-800">
                            <X size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 text-sm text-gray-900">{item?.size}</td>
                      <td className="px-4 py-2 text-sm font-medium text-gray-900">{item?.price}€</td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button
                            onClick={() => handleEditItem('cantines', item)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteItem('cantines', item?.id)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Mobilier */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">🪑 Mobilier</h3>
          <button
            onClick={() => handleAddItem('mobilier')}
            className="text-sm bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Article</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Unité</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Prix (€)</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pricingData?.mobilier?.map((item) => (
                <tr key={item?.id}>
                  {editingItem?.category === 'mobilier' && editingItem?.id === item?.id ? (
                    <>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.name}
                          onChange={(e) => setEditForm({ ...editForm, name: e?.target?.value })}
                          className="w-full px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.unit}
                          onChange={(e) => setEditForm({ ...editForm, unit: e?.target?.value })}
                          className="w-24 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.price}
                          onChange={(e) => setEditForm({ ...editForm, price: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button onClick={handleSaveEdit} className="text-green-600 hover:text-green-800">
                            <Save size={16} />
                          </button>
                          <button onClick={handleCancelEdit} className="text-gray-600 hover:text-gray-800">
                            <X size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 text-sm text-gray-900">{item?.name}</td>
                      <td className="px-4 py-2 text-sm text-gray-600">{item?.unit}</td>
                      <td className="px-4 py-2 text-sm font-medium text-gray-900">{item?.price}€</td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button
                            onClick={() => handleEditItem('mobilier', item)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteItem('mobilier', item?.id)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Cartons */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">📦 Cartons (Effets Personnels)</h3>
          <button
            onClick={() => handleAddItem('cartons')}
            className="text-sm bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 flex items-center space-x-1"
          >
            <Plus size={16} />
            <span>Ajouter</span>
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Dimensions</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Prix (€)</th>
                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pricingData?.cartons?.map((item) => (
                <tr key={item?.id}>
                  {editingItem?.category === 'cartons' && editingItem?.id === item?.id ? (
                    <>
                      <td className="px-4 py-2">
                        <input
                          type="text"
                          value={editForm?.dimensions}
                          onChange={(e) => setEditForm({ ...editForm, dimensions: e?.target?.value })}
                          className="w-full px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <input
                          type="number"
                          value={editForm?.price}
                          onChange={(e) => setEditForm({ ...editForm, price: parseFloat(e?.target?.value) })}
                          className="w-20 px-2 py-1 border rounded"
                        />
                      </td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button onClick={handleSaveEdit} className="text-green-600 hover:text-green-800">
                            <Save size={16} />
                          </button>
                          <button onClick={handleCancelEdit} className="text-gray-600 hover:text-gray-800">
                            <X size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 text-sm text-gray-900">{item?.dimensions}</td>
                      <td className="px-4 py-2 text-sm font-medium text-gray-900">{item?.price}€</td>
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center space-x-2">
                          <button
                            onClick={() => handleEditItem('cartons', item)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteItem('cartons', item?.id)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-6">
        <div className="space-y-3">
          <p className="text-sm text-green-800">
            <strong>💡 Comment Fatou utilise cette grille tarifaire:</strong>
          </p>
          <ul className="text-sm text-green-700 space-y-2 ml-4 list-disc">
            <li><strong>Réponse directe:</strong> Fatou donnera immédiatement le prix exact selon les dimensions/type d'article</li>
            <li><strong>Transit maritime:</strong> Fatou expliquera que le tarif est basé sur le volume, pas le poids</li>
            <li><strong>Exclusions:</strong> Fatou informera automatiquement le client si un article est dans la liste des exclusions</li>
            <li><strong>Précision:</strong> Pour les téléviseurs, Fatou demandera si c'est occasion ou neuf avant de donner le prix</li>
          </ul>
        </div>
      </div>
    </div>
  );
}